import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchCampaignStatuses } from '../api-client';

export function useLauncherStatuses(id: string) {
  const { apiFetch } = useApi();

  const query = useQuery<string[]>({
    queryKey: ['launcher', 'campaigns', id, 'statuses'],
    queryFn: () => fetchCampaignStatuses(apiFetch, id),
    enabled: !!id,
  });

  return {
    statuses: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
